import logger from '@/modules/Logger';

export default {
  // publish local stream to channel
  async publishStreamToChannel() {
    this.constraints.cameraId = this.videoDevice || null;
    this.constraints.microphoneId = this.audioDevice || null;
    this.localTracks = [];

    // Check if new constraints are applied
    logger.debug(`New Device Constraints: ${JSON.stringify(this.constraints)}`);

    await this.createMicrophoneTracks();

    if (this.videoEffect !== 'none') {
      await this.createVbackgroundTrack();
    } else if (this.constraints.video) {
      await this.createCameraTracks();
    }

    return await this.publishTracks();
  }
}

